// 区域code
const areaTypeMap = {
	cn: 'cn', // 大陆
	hmt: 'hmt', // 港澳台
	ibu: 'ibu' // 国际
}
const recTypeMap = {
	canRec: 'canRec', // 可以收寄
	forbidRec: 'forbidRec', // 禁止收寄
	limitRec: 'limitRec' // 限制收寄
}
// 热门搜索项
const hotItemsMap = {
	cn: [
		'衣服', '文件', '手机', '电池', '电脑', '鞋子', '茶叶', '口罩'
	],
	hmt: [
		'文件', '衣服', '腊肉', '茶叶', '化妆品', '鞋子', '口罩', '手机'
	],
	ibu: [
		'文件', '衣服', '腊肉', '茶叶', '化妆品', '鞋子', '口罩', '手机'
	]
}

// 区域选择tab
const areaMap = [
	{
		name: '内地互寄',
		code: areaTypeMap.cn,
		areaTypeList: [areaTypeMap.cn]
	},
	{
		name: '港澳台寄递',
		code: areaTypeMap.hmt,
		areaTypeList: [areaTypeMap.cn, areaTypeMap.hmt]
	},
	{
		name: '国际寄递',
		code: areaTypeMap.ibu,
		areaTypeList: [areaTypeMap.cn, areaTypeMap.hmt, areaTypeMap.ibu]
	}
]
export {
	hotItemsMap, areaMap, areaTypeMap, recTypeMap
}



// WEBPACK FOOTER //
// ./src/pages/recStandard/config.js